import {
  selectBlocksByNode,
  selectNodeChildren,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'

export const collectNodeWithChildren = (
  nodeId: string,
  index: number,
  state: AppState
): any => {
  const node = migrationProjectSelector.getProjectNodeById(nodeId)(state)
  const blockIds = selectBlocksByNode(nodeId)(state)
  const childrenIds = selectNodeChildren(nodeId)(state)

  const blocks = blockIds
    .map((blockId, blockIndex) => {
      const block =
        migrationProjectSelector.getProjectBlockOrSymbolData(blockId)(state)

      if (!block) {
        return null
      }

      const wireframes =
        block.visual.type === 'wireframes' ? block.visual.wireframes : []
      return {
        type: 'block',
        id: blockId,
        index: blockIndex,
        title: block.title,
        colorId: block.colorId,
        wireframes,
      }
    })
    .filter(Boolean)

  const children = childrenIds.map((childId, childIndex) =>
    collectNodeWithChildren(childId, childIndex, state)
  )

  return {
    type: 'node',
    id: nodeId,
    index,
    title: node.title,
    colorId: node.colorId,
    collapsed: node.collapsed,
    blocks,
    children,
  }
}
